// @core/api/endpoints/product/list_product_dependencies.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListProductDependenciesResponse,
} from '../../../types/product';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/product';

/**
 * List product dependencies
 * Returns all dependencies declared by this product. Optionally includes reverse dependencies (products that depend on this one).
 * @public This endpoint does not require authentication
 */
export async function ListProductDependencies(
  product_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListProductDependenciesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/products/:product_id/dependencies`;
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = { ...options, skipAuth: true };
  return client.get<ListProductDependenciesResponse>(requestPath, { ...requestOptions, params });
}
